import { createFileRoute } from "@tanstack/react-router";

import { POST_LOGIN_REDIRECT_PATH } from "@/features/auth/constants/auth.constants";
import { Onboarding } from "@/features/onboarding/modules/onboarding/onboarding";
import { m } from "@/paraglide/messages.js";

export const Route = createFileRoute("/onboarding/")({
  component: RouteComponent,
  loader: () => {
    return {
      crumb: m.onboarding_crumb(),
    };
  },
});

function RouteComponent() {
  const { invitation_token, redirect } = Route.useSearch();

  return (
    <Onboarding
      initialPath={invitation_token ? "join" : undefined}
      invitationToken={invitation_token}
      redirectTo={redirect ?? POST_LOGIN_REDIRECT_PATH}
    />
  );
}
